export const decapitalize = (toChange: string) => (toChange ? toChange[0].toLowerCase() + toChange.slice(1) : '');
